/*
When doing an "each" filter we don't have any structured data in the returned data series about which filter was used.
The series name does have a concatenated list of the filters applied, so this transformer updates the series name
to the last segment of the full name. When only using one "each" filter in a query and some good luck you might
get the right name.
 */
export default function seriesUpdateNameUsingLastSegment(dataSeries) {
    dataSeries.forEach((series) => {
        if (typeof series.shortName !== "undefined") {
            // Try to find filters in the series name by looking for words separated by a comma
            const words = series.shortName.split(", ");
            if (words.length > 1) {
                // If there is more than one word, assume the last word is a filter and use that as
                // the series name.
                series.name = words[words.length - 1];
            }
            else {
                // Otherwise just use the default short name.
                series.name = series.shortName;
            }
        }
    });
    return dataSeries;
}
